import { MAX_MESSAGE_LENGTH } from './constants';

export function validateMessage(text) {
  const t = (text ?? '').trim();
  if (!t) return { valid: false, error: 'Message is empty' };
  if (t.length > MAX_MESSAGE_LENGTH) {
    return { valid: false, error: `Max ${MAX_MESSAGE_LENGTH} characters` };
  }
  return { valid: true };
}
